/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ErpFilter } from './ErpFilter';
import {
    ErpFilterFromJSON,
    ErpFilterFromJSONTyped,
    ErpFilterToJSON,
    ErpFilterToJSONTyped,
} from './ErpFilter';

/**
 * 
 * @export
 * @interface PeriodComparisonInput
 */
export interface PeriodComparisonInput {
    /**
     * 
     * @type {ErpFilter}
     * @memberof PeriodComparisonInput
     */
    current?: ErpFilter;
    /**
     * 
     * @type {ErpFilter}
     * @memberof PeriodComparisonInput
     */
    previous?: ErpFilter;
    /**
     * 
     * @type {ErpFilter}
     * @memberof PeriodComparisonInput
     */
    previousYear?: ErpFilter;
}

/**
 * Check if a given object implements the PeriodComparisonInput interface.
 */
export function instanceOfPeriodComparisonInput(value: object): value is PeriodComparisonInput {
    return true;
}

export function PeriodComparisonInputFromJSON(json: any): PeriodComparisonInput {
    return PeriodComparisonInputFromJSONTyped(json, false);
}

export function PeriodComparisonInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PeriodComparisonInput {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : ErpFilterFromJSON(json['current']),
        'previous': json['previous'] == null ? undefined : ErpFilterFromJSON(json['previous']),
        'previousYear': json['previousYear'] == null ? undefined : ErpFilterFromJSON(json['previousYear']),
    };
}

export function PeriodComparisonInputToJSON(json: any): PeriodComparisonInput {
    return PeriodComparisonInputToJSONTyped(json, false);
}

export function PeriodComparisonInputToJSONTyped(value?: PeriodComparisonInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': ErpFilterToJSON(value['current']),
        'previous': ErpFilterToJSON(value['previous']),
        'previousYear': ErpFilterToJSON(value['previousYear']),
    };
}

